import {RecordsStateType, ActionType, reducerStoreType} from "./types";

const defaultState = {
    RecordsFilters: {
        clientId: '',
        email: '',
        currentPage: 1,
        recordsPerPage: 20,
        startDate: '',
        endDate: '',
        status: -1
    },
	RecordsInfo: {
		total: 0,
		list: []
	}
}

const exchangeRecords = (state: RecordsStateType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
		case 'SET_RECORDS_INFO':
			return {
				...state,
				RecordsInfo: action.payload
			}
		case 'SET_EXCHANGE_RECORDS_DATE':
			return {
				...state,
				RecordsFilters: {
					...state.RecordsFilters,
					startDate: action.payload.startDate,
					endDate: action.payload.endDate
				}
			}
		case 'SET_EXCHANGE_RECORDS_STATUS':
			return {
				...state,
				RecordsFilters: {
					...state.RecordsFilters,
					status: action.payload.Status
				}
			}
		case 'CLEAR_EXCHANGE_RECORDS_FILTERS':
			return {
				...state,
				RecordsFilters: {
					...defaultState.RecordsFilters
				}
			}
		case 'SET_PAGE_INDEX':
			return {
				...state,
				RecordsFilters: {
					...state.RecordsFilters,
					currentPage: action.payload.currentPage
				}
			}
		case 'SET_PAGE_SIZE':
			return {
				...state,
				RecordsFilters: {
					...state.RecordsFilters,
					currentPage: action.payload.currentPage,
					recordsPerPage: action.payload.recordsPerPage,
				}
			}
		case 'RESET_PAGE_INFO': {
			return {
				...state,
				RecordsFilters: {
					...state.RecordsFilters,
					currentPage: action.payload.currentPage,
					recordsPerPage: action.payload.recordsPerPage,
				}
			}
		}
		default:
		    return state;
    }
}

export const recordsFilters = (state:reducerStoreType) => (state.exchangeRecords.RecordsFilters)
export const exchangeRecordsList = (state:reducerStoreType) => (state.exchangeRecords.RecordsInfo.list)
export default exchangeRecords